import styled from 'styled-components'

const EasyToClickIcon = styled.i`
  position: relative;

  &::after {
    content: '';
    position: absolute;
    width: 1.25em;
    height: 1.25em;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

export default EasyToClickIcon



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/EasyToClickIcon.js